import { NavLink, useLocation } from 'react-router-dom';
// import { FiBell } from 'react-icons/fi';
import Logo from './img/aiforbi.png';
import './css/style.scss';
import Profile from './profile';
import UserContext from '../../configs/userContext';

const NavBar = ({ usertype = 'default' }) => {
  const menu = ['Home', 'Chat', 'Alerts', 'FAQs'];
  const adminmenu = [
    {
      parent: 'Configuration',
      prefix: 'admin/',
      child: []
    },
    {
      parent: 'User-Access-Management',
      name: 'UAM',
      prefix: 'admin/',
      child: []
    },
    {
      parent: 'Usage',
      prefix: 'admin/',
      child: []
    }
  ];

  const match = useLocation().pathname === '/';
  const adminmatch = useLocation().pathname === '/admin';
  const profile_component = 'user-profile';

  return (
    <UserContext.Consumer>
      {(userContext) => {
        const user = userContext;
        const { first_name, last_name } = user;
        const name = first_name + ' ' + last_name;
        const shortname = name.length > 0 ? first_name[0] + last_name[0] : first_name[0];
        return (
          <div id='nav-bar' className='row justify-content-center m-0'>
            <div className='reduced-row d-flex'>
              <div className='nav-links w-100'>
                <div className='navbar-logo'>
                  <img src={Logo} alt='Accenture' />
                </div>
                {/* Routes for all users */}
                {usertype === 'default' &&
                  menu.map((x, i) => {
                    const active = match && x.toLowerCase() === 'home' ? 'active' : '';
                    return (
                      <NavLink className={`option ${active}`} to={'/' + x.toLowerCase()} key={i}>
                        {x.replaceAll('-', ' ')}
                      </NavLink>
                    );
                  })}
                {/* Routes for admin users */}
                {usertype !== 'default' &&
                  adminmenu.map((x, i) => {
                    const active =
                      adminmatch && x.parent.toLowerCase().includes('user-access-management')
                        ? 'active'
                        : '';
                    return (
                      <NavLink
                        className={`option ${active}`}
                        to={'/' + x.prefix + x.parent.toLowerCase()}
                        key={i}
                      >
                        {Object.keys(x).includes('name') ? x.name : x.parent.replaceAll('-', ' ')}
                      </NavLink>
                    );
                  })}
                {/* Notification & Profile */}
                <div className='user-meta'>
                  {/* {usertype === 'default' && (
                    <>
                      <FiBell className='notification' />
                      <div className='separator'>
                        <div className='line'></div>
                      </div>
                    </>
                  )} */}
                  <div className='welcome'>Welcome</div>
                  <div
                    className='user-circle'
                    data-bs-toggle='offcanvas'
                    data-bs-target={'#' + profile_component}
                    aria-controls={profile_component}
                  >
                    {shortname}
                  </div>
                  <Profile id={profile_component} user={user} />
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </UserContext.Consumer>
  );
};

export default NavBar;
